import { useQuery } from 'react-query';
import { getMetric } from '../api/getMetric';

const useMetric = (metricName, patientMetric = 0) => {
  const result = useQuery('metric_' + metricName + patientMetric, () => getMetric(metricName, patientMetric), {
    refetchOnWindowFocus: false,
    staleTime: metricName === 'patient_lists' || metricName === 'alert' ? 1000 : 50000,
  });
  return result;
};

export default useMetric;
